export default {
    manage_deleteWorkOrder_title: "Delete Work Order",
    manage_deleteWorkOrders_title: "Delete Work Orders",
    manage_deleteWorkOrders_description: "Are you sure you want to delete the Work Orders?",
    manage_deleteWorkOrder_description: "Are you sure you want to delete this Work Order?",
    manage_deleteWorkOrder_successMessage: "Work Order deleted",
    manage_deleteWorkOrders_successMessage: "Work Orders deleted",
    manage_deleteWorkOrders_are_in_use: "It is not possible to delete work orders in use",
}